import type { ResourceFilterKey } from '@/lib/api/types/itemFilters';

export const RESOURCE_PICKLIST_FILTERS = [
  'locationId',
  'roleId',
  'skillId',
  'holidaySchemeId',
  'workloadSchemeId',
] as const satisfies readonly ResourceFilterKey[];

export const RESOURCE_BOOLEAN_FILTERS = [
  'showDeactivatedMembers',
] as const satisfies readonly ResourceFilterKey[];

export const RESOURCE_FILTER_KEYS = [
  ...RESOURCE_PICKLIST_FILTERS,
  ...RESOURCE_BOOLEAN_FILTERS,
] as const satisfies readonly ResourceFilterKey[];

export const getResourceTableFilters = () => [...RESOURCE_FILTER_KEYS] as const;
